<!-- <div>
    <h1 mat-dialog-title style="text-align: center;margin: 0%; border-bottom-style: inset;">{{data.title}}</h1>
    <mat-dialog-content style="margin-top: 4% ;">
      <div style="text-align: center;">Failed<br />
        <span style="font-style: italic;">
         User Createion 
        </span>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions style="justify-content: space-around;">
        <button mat-button mat-dialog-close>Cancel</button>
       <button mat-raised-button  style="background-color: darkslategrey;color: #fff;" (click)='close(false)'>Cancell</button>
    </mat-dialog-actions>
  </div>
   -->

   <div class="header title-position" style=" height: 70px; ">
    <h1 mat-dialog-title>{{data?.title }}</h1>
</div>
<div mat-dialog-content style=" position: relative; top: -23px;">
    <p class="dialog-message">{{data?.message}}</p>
</div>
<div mat-dialog-actions *ngIf="data.confirmText != undefined" style=" position: relative; top: -30px; height: 0px;">
  <button class="btn btn btn-danger btn-Delete" (click)="confirm()" style="left: 32% !important; height: 34px; font-size: 14px;" *ngIf="data.confirmText != undefined">{{data?.confirmText}}</button>
  <button class="btn btn-primary btn-Cancel" style="left: 34% !important; color: white; background-color: #2f72ab; height: 34px; font-size: 14px; " (click)="cancel()">{{ data?.cancelText }}</button>

</div>

<div mat-dialog-actions *ngIf = "data.confirmText == undefined" style=" position: relative; top: -30px; height: 0px;">
  
  <button class="btn btn-primary btn-Ok" style="color: white; background-color: #2f72ab; height: 34px; font-size: 14px;"  (click)="cancel()">{{ data?.cancelText }}</button>
  
</div>

  
